import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {NotificationsService} from "@/services/api/notifications.js";
import { handleApiError } from '@/services/errorHandler.js'

export const useNotificationsStore = defineStore('notifications', () => {
  const notifications = ref([]);
  const isFetching = ref(false);
  const websocketConnected = ref(false);
  const unreadCount = computed(() => {
    return notifications.value.filter(n => !n.read_at).length;
  });

  async function fetchNotifications() {
    if (isFetching.value) return;
    isFetching.value = true;

    try {
      const response = await NotificationsService.list();
      notifications.value = Array.isArray(response.data) ? response.data : [];
    } catch (e) {
      handleApiError(e, { title: 'Failed to load notifications', silent: true })
    } finally {
      isFetching.value = false;
    }
  }

  async function markAsRead(notificationId) {
    try {
      await NotificationsService.read(notificationId);
      const n = notifications.value.find(x => x.id === notificationId);
      if (n && !n.read_at) {
        n.read_at = new Date().toISOString();
      }
    } catch (e) {
      handleApiError(e, { title: 'Failed to mark notification as read' })
    }
  }

  async function markAllAsRead() {
    try {
      await NotificationsService.readAll();

      const now = new Date().toISOString();
      notifications.value.forEach((n) => {
        if (!n.read_at) n.read_at = now;
      });
    } catch (e) {
      handleApiError(e, { title: 'Failed to mark all notifications as read' })
    }
  }

  return {
    notifications,
    unreadCount,
    isFetching,
    websocketConnected,
    fetchNotifications,
    markAsRead,
    markAllAsRead,
  };
});
